const mapInventoryDestinationsFromApi = (destinations) => {
    return destinations.map(dest => ({
        id: dest.destinationFulfillmentCenterId,
        name: dest.destinationFulfillmentCenterName,
        destinationHubFulfillmentCenterId: dest.destinationHubFulfillmentCenterId,
        destinationFulfillmentCenterTypeId: dest.destinationFulfillmentCenterTypeId,
        distributionAllowed: dest.distributionAllowed
    }))  
}

export default {
    mapInventoryDestinationsFromApi
  }